import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { createApp } from 'vue';
import router from './router';
import App from './App.vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueSmoothScroll from 'vue3-smooth-scroll';


const app = createApp(App);



app.use(router);
app.use(VueAxios, axios);
app.use(VueSmoothScroll);

app.mount('#app');
